import React from "react";
import ReactHtmlParser from "react-html-parser";
import { FavoriteIcon } from "../../../Icons/icons.component";
import { FEED_DETAILS } from "../../../../constants/route-constants";
import { DATE_FORMATS, MEDIA_TYPES } from "../../../../constants/app-constant";
import ArticleTags from "../ArticleTags";
import { formatDate, groupBy } from "../../../../utility/common-methods";

export default function SingleFeedItem({
  isPrint,
  isOnline,
  feed,
  editionList = [],
  newsDetails,
  allArticleList,
  onFeedSelect,
  singleNewsGroup,
  isNewsDetailsMain,
  other_edition_url_html,
  selectedFeeds,
  forEmbedArticles,
  updatedBulkTheme,
  updatedBulkSentiment,
  updatedBulkFavourite,
  isTV
}) {
  if (!feed) {
    return null;
  }
  const {
    headline,
    publication,
    source,
    source_name,
    edition,
    article_id,
    client_id,
    entity_id,
    website_type,
    website_url,
    page_nos,
    publish_date,
    Forclient_id,
    language,
    channel_name, program_name,
    airing_date,
    airing_time,
    video_link,
    anchor_details,
    electronic_id,
            channel_type,
            duration,
            anchors
  } = feed;

  const handleArticleClick = (e, article) => {
    e.preventDefault();
    e.stopPropagation();
    let correctedId = article_id;
    if (article) {
      correctedId = article.article_id;
    }
    if (allArticleList)
      localStorage.setItem("articleIdList", JSON.stringify(allArticleList));

    if (isPrint) {
      window.open(
        `https://${window.location.host}${FEED_DETAILS}/${MEDIA_TYPES.PRINT_MV
        }/${client_id || Forclient_id}-${correctedId}-${entity_id}`,
        "_blank"
      );
    }

    if (isOnline) {
      if (newsDetails || website_type === "International") {
        window.open(website_url);
      } else {
        window.open(
          `https://${window.location.host}${FEED_DETAILS}/${MEDIA_TYPES.ONLINE_MV
          }/${client_id || Forclient_id}-${correctedId}-${entity_id}`,
          "_blank"
        );
      }
    }
    if (isTV) {
      window.open(`${video_link}`, "_blank");
    }
  };

  const renderEditionDetails = () => {
    if (isNewsDetailsMain && other_edition_url_html) {
      const { host, protocol } = window.location;
      const newHost = `${protocol}//${host}`;
      let newUrls = other_edition_url_html
        .replaceAll("http://clientportal.conceptbiu.com", newHost)
        .replaceAll("https://clientportal.conceptbiu.com", newHost)
        .replaceAll("href", 'class="nav-item nav-link" href')
        .replaceAll(" | ", "");

      let activeEdition = newUrls.match(
        /^[\*\s\w]*|[^\>]+(?=\<a )|[\*\s\w]*$/gs
      );
      if (activeEdition && activeEdition.length > 0) {
        const str = activeEdition.find((i) => i);
        newUrls = newUrls.replace(
          str,
          `<span class="nav-item active">${str}</span>`
        );
      }
      return <>{ReactHtmlParser(newUrls)}</>;
    }

    const showSingleEdition =
      (Array.isArray(singleNewsGroup) && singleNewsGroup.length == 0) ||
      isOnline;

    return (
      <>
        {showSingleEdition ? (
          <span className="editions activeEdition">
            {edition || (isOnline ? "Online Web" : "Print")}
          </span>
        ) : (
          singleNewsGroup.map((el, index) => {
            const { edition, abbreviation } = el;
            const editionFaceValue = abbreviation
              ? abbreviation.toUpperCase()
              : edition;

            return (
              <>
                <span
                  className="link"
                  onClick={(e) => handleArticleClick(e, el)}
                >
                  {editionFaceValue || "NA"}
                </span>
                {index < singleNewsGroup.length - 1 && ", "}
              </>
            );
          })
        )}
      </>
    );
  };

  const isSingleFeedSelected = () => {
    if (!isTV) {
      const tempArr =
        selectedFeeds &&
        selectedFeeds.filter(
          (f) => f.article_id == feed.article_id && f.entity_id == feed.entity_id
        );
      return tempArr && tempArr.length;
    }
    if (isTV) {
      const tempArr = selectedFeeds && selectedFeeds.filter((f)=>f.electronic_id == feed.electronic_id)
      return tempArr && tempArr.length
    }
  };


  return (
    <div className={isPrint || isOnline?"":"innerFeedItem"}>
      <div className="headlineWrapper">
        <label className="inputWrap">
          <input
            type="checkbox"
            onChange={(e) =>
              onFeedSelect &&
              onFeedSelect( !isSingleFeedSelected(), isTV ? feed : singleNewsGroup )
            }
            checked={isSingleFeedSelected()}
          />
          <span className="checkmark"></span>
        </label>
        <label
          className="headlineLabel clickable"
          onClick={(e) => handleArticleClick(e)}
        >
          {headline}
        </label>
        {!forEmbedArticles && (
          <div className="rightContainer">
            <ul className="dropDownContainer">
              <ArticleTags
                key={`${article_id}`}
                article={feed}
                singleNewsGroup={singleNewsGroup}
                mediaType={isOnline ? "online" : "print"}
                updatedBulkTheme={updatedBulkTheme}
                updatedBulkSentiment={updatedBulkSentiment}
                updatedBulkFavourite={updatedBulkFavourite}
                isSingleFeedSelected={isSingleFeedSelected()}
                showFavouriteTag
                isPrintAndOnline
                isTV={isTV}
                isOnline={isOnline}
                isPrint={isPrint}
                showTicket={true}
              />
            </ul>
          </div>
        )}
      </div>

      {!isTV && <ul className="card-entities">
        {isOnline ? (
          <li className="publication">
            <span className="label-span">Website :</span>{" "}
            <span
              className="data-span link"
              onClick={() => window.open(website_url)}
            >
              {publication}
            </span>
          </li>
        ) : (
          <li className="publication">
            <span className="label-span">Publication :</span>{" "}
            <span className="data-span">{publication}</span>
          </li>
        )}
        <li className="source">
          <span className="label-span">Source :</span>
          <span className="data-span">{source_name}</span>
        </li>
        {isOnline ? (
          <li className="languae">
            <span className="label-span">Language :</span>
            <span className="data-span">{language}</span>
          </li>
        ) : (
          <li className="edition">
            <span className="label-span">Edition :</span>{" "}
            <span className="data-span">{renderEditionDetails()}</span>
          </li>
        )}
        {isPrint && (
          <li className="pageNum">
            <span className="label-span">Page No :</span>
            <span className="data-span">{page_nos}</span>
          </li>
        )}
        <li className="publishDate">
          <span className="label-span">Publish Date :</span>

          <span className="data-span">
            {" "}
            {formatDate(publish_date, DATE_FORMATS.DDMMYYYY_dash)}
          </span>
        </li>
      </ul>}

      {isTV && <ul className="card-entities">
        <li className="source">
          <span className="label-span">Channel :</span>
          <span className="data-span">{channel_name}</span>
        </li>
        <li className="source">
          <span className="label-span">Reporter :</span>
          <span className="data-span">{anchor_details.length && anchor_details.map(({ anchor_name }) => anchor_name)}</span>
        </li>
        <li className="source">
          <span className="label-span">Programme :</span>
          <span className="data-span">{program_name}</span>
        </li>
        <li className="source">
          <span className="label-span">Time :</span>
          <span className="data-span">{airing_time}</span>
        </li>
        <li className="source">
          <span className="label-span">Date :</span>
          <span className="data-span">{airing_date}</span>
        </li>
      </ul>}

    </div>
  );
}
